<div id="iframe-portalV1">
  <div *ngIf="!loading" class="layout-main">
    <div class="container-fluid">
      <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
        <nav *ngIf="loggedInUser && loggedInUser.company" aria-label="breadcrumb" class="navbar-nav mr-auto">
          <ol class="breadcrumb ol-sf-1">
            <li class="breadcrumb-item">
              <a *ngIf="loggedInUser.permissions.isMckayUser"
                 routerLink="/mckay/{{loggedInUser.company.uniqid}}">Home</a>
              <a *ngIf="!loggedInUser.permissions.isMckayUser"
                 routerLink="/client/{{loggedInUser.company.uniqid}}">Home</a>
            </li>
            <li class="breadcrumb-item">
              <a routerLink="/quincy-etrees">List Quincy etree</a>
            </li>
            <li *ngIf="currentEtree && currentEtree.name" aria-current="page" class="breadcrumb-item active">
              {{ currentEtree.name }}
            </li>
          </ol>
        </nav>
      </nav>
      <div *ngIf="currentEtree && loading===false" class="pb-2 mb-3 border-bottom">
        <h3>Etree  {{ currentEtree.name }} overview</h3>
        <div class="p-grid p-fluid">
          <div class=" col-12 col-md-6">
            <div class="p-grid p-fluid">
              <div class="col-12">
                <p-fieldset [collapsed]="false" [toggleable]="true">
                  <ng-template pTemplate="header">E-Tree summary</ng-template>
                  <ul>
                    <li>Name: {{ currentEtree.name }}</li>
                    <li>Bandwidth: {{ currentEtree.bandwidth }}</li>
                    <li>Injection pop: {{ currentEtree.marsInjectionPoint.site_technical_name }}</li>
                    <li>Etree Uuid: {{ currentEtree.id }}</li>
                  </ul>
                </p-fieldset>
              </div>
              <div *ngIf="(currentEtree.macAdresses && currentEtree.macAdresses.length > 0) || (currentEtree.priorities && currentEtree.priorities.length > 0) "
                   class=" col-12">
                <p-fieldset [collapsed]="false" [toggleable]="true">
                  <ng-template pTemplate="header">Sps & Mac addresses list</ng-template>
                  <ul>
                    <ng-container *ngFor="let priority of currentEtree.priorities">
                      <li *ngIf="priority['global_priority']==='4'">
                        High Priority Buffer: {{ priority['queue_size'] }}
                      </li>
                      <li *ngIf="priority['global_priority']==='2'">
                        Low Priority Buffer: {{ priority['queue_size'] }}
                      </li>
                    </ng-container>
                    <li *ngIf="currentEtree.macAdresses.length > 0">
                      <div class="p-grid p-fluid">
                        <div class=" col-12">
                          Sps Mac Entries:
                        </div>
                        <div class=" col-12">
                          <p-table [value]="currentEtree.macAdresses">
                            <ng-template pTemplate="header">
                              <tr>
                                <th>#</th>
                                <th>source</th>
                                <th>destination</th>
                              </tr>
                            </ng-template>
                            <ng-template let-row let-rowIndex="rowIndex" pTemplate="body">
                              <tr>
                                <td>{{ rowIndex + 1 }}</td>
                                <td>{{ row['source'] }}</td>
                                <td>{{ row['destination'] }}</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                      <div class="p-grid p-fluid">
                        <button (click)="createCsvFile()" class="p-button-success pull-right" icon="fa fa-download"
                                label="Download SPS & MAC list"
                                pButton
                                style="width: 33%"
                                type="submit"></button>
                      </div>

                    </li>
                  </ul>
                </p-fieldset>
              </div>
            </div>
          </div>
          <div class=" col-12 col-md-6">
            <div class="col-12 p-fluid">
              <p-fieldset [collapsed]="false" [toggleable]="true">
                <ng-template pTemplate="header">Manage MAC address</ng-template>
                <div *ngIf="macAddressArray.length > 0" class="row">
                  <p [innerHTML]="macAddressHeader" class="d-inline">
                  </p>&nbsp;
                  <p class="d-inline mb-1"> <span
                    *ngIf="csvDatabaseFileToDwonloadBlob && uploadedMacAddressArray.length ===0">
                                <a (click)="downloadMAcListAsCsv()" [routerLink]="">(Download) </a> </span></p>
                  <br/>
                  <br/>
                  <p-table [value]="macAddressArray">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>#</th>
                        <th>source</th>
                        <th>destination</th>
                      </tr>
                    </ng-template>
                    <ng-template let-row let-rowIndex="rowIndex" pTemplate="body">
                      <tr>
                        <td>{{ rowIndex + 1 }}</td>
                        <td>{{ row[0] }}</td>
                        <td>{{ row[1] }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
                <div class="col-12">
                  <form [formGroup]="macUploadForm">
                    <div class="p-grid p-fluid">
                      <div [ngClass]="{'has-error': showMacUploadFormErrorMessage('macAdresseFile')}"
                           class="form-group col-12 row">
                        <label class="col-2" for="macAdresseFile">
                          MAC file UPLOAD:
                        </label>
                        <div class="col-7 pull-left col-form-input p-inputgroup">
                          <p-fileUpload (onClear)="clearMacFileUpload()" (onRemove)="clearMacFileUpload()" (uploadHandler)="uploadMacFile($event)"
                                        accept="text/csv"
                                        customUpload="true"
                                        id="macAdresseFile"
                                        name="macAdresseFile"
                                        showCancelButton="true">

                          </p-fileUpload>
                        </div>
                        <div class="col-3">
                          <button (click)="transmitMacFile()" [disabled]="uploadedMacAddressHeader.length === 0" class="p-button-success pull-left"
                                  icon="fa fa-floppy-o"
                                  label="Transmit to Mckay"
                                  pButton
                                  type="submit">
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </p-fieldset>
            </div>
            <div class="col-12 p-fluid">
              <p-fieldset [collapsed]="false" [toggleable]="true">
                <ng-template pTemplate="header">Update buffer priorities</ng-template>
                <div [innerHTML]="bufferDataHeader" class=" col-12">

                </div>
                <div class="col-12">
                  <form [formGroup]="bufferPriorityForm">
                    <div class="p-grid p-fluid">
                      <div [ngClass]="{'has-error': showBufferPrioritiesErrorMessage('highPriority')}"
                           class="form-group col-12 row">
                        <label class="col-3 col-form-label" for="highPriority">
                          High priority :
                        </label>
                        <div class="col-3 pull-left col-form-input p-inputgroup">
                          <p-spinner [formatInput]="false" [min]="0"
                                     [size]="2" formControlName="highPriority" id="highPriority">
                          </p-spinner>
                        </div>
                        <div class="col-6">(Select number of packets)</div>
                      </div>
                      <div [ngClass]="{'has-error': showBufferPrioritiesErrorMessage('lowPriority')}"
                           class="form-group col-12 row">
                        <label class="col-3 col-form-label" for="lowPriority">
                          Low priority :
                        </label>
                        <div class="col-3 col-form-input p-inputgroup">
                          <p-spinner [formatInput]="false" [min]="0" [size]="2"
                                     formControlName="lowPriority"
                                     id="lowPriority">
                          </p-spinner>
                        </div>
                        <div class="col-6">
                          <button (click)="saveBufferPriorities()" [disabled]="!bufferPriorityForm.valid" class="p-button-success pull-right"
                                  icon="fa fa-floppy-o"
                                  label="Save and transmit to Mckay"
                                  pButton
                                  type="submit"></button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </p-fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
